import { motion } from "framer-motion";
import { Reveal, Kicker } from "@/components/Reveal";
import { LogoSymbol } from "@/components/Logo";

const CHAIN = ["SOCIAL", "ATTENZIONE", "VIRALITÀ", "VISIBILITÀ", "BRAND", "CRESCITA"];

export const Concept = () => (
  <section id="concetto" data-testid="concept-section" className="relative overflow-hidden bg-white bg-grid-light py-24 lg:py-32">
    <LogoSymbol className="pointer-events-none absolute -right-8 top-8 w-[300px] opacity-[0.07]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Kicker>Il concetto</Kicker>
        <h2 className="mt-5 max-w-4xl font-display text-4xl font-black leading-[1.0] tracking-tight text-navy sm:text-6xl">
          IL NOME È IL METODO: <span className="text-brand-gradient">SI PARTE DAI SOCIAL.</span>
        </h2>
      </Reveal>

      <div className="mt-10 max-w-3xl">
        <Reveal delay={0.1}>
          <p className="text-lg font-semibold leading-relaxed text-navy sm:text-xl">
            Starting Point significa punto di partenza. E oggi il punto di partenza di ogni brand sono i social: è lì che si conquista l'attenzione.
          </p>
          <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
            Se un contenuto diventa virale, tutto il resto funziona meglio: il brand diventa riconoscibile, la fiducia cresce, le opportunità arrivano. Per questo partiamo dai social — e poi costruiamo intorno tutto ciò che serve: identità, siti web, advertising, comunicazione offline.
          </p>
        </Reveal>
      </div>

      <div className="mt-12 flex flex-wrap items-center gap-y-4" data-testid="concept-chain">
        {CHAIN.map((step, i) => (
          <motion.div
            key={step}
            className="flex items-center"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className={`rounded-full px-5 py-2.5 font-display text-xs font-extrabold tracking-[0.12em] sm:text-sm ${
              step === "VIRALITÀ"
                ? "bg-brand-gradient text-white shadow-lg"
                : step === "CRESCITA"
                ? "bg-navy text-white"
                : "border border-navy/15 bg-white text-navy"
            }`}>
              {step}
            </span>
            {i < CHAIN.length - 1 && (
              <svg viewBox="0 0 24 24" className="mx-3 h-4 w-4 shrink-0 text-brand-blue" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 12h14" /><path d="m13 6 6 6-6 6" />
              </svg>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
